import { createFileRoute } from '@tanstack/react-router';
import UserLayout from '@components/layout/UserLayout.tsx';
import { ReportPage } from '@features/client/reports';
import { priceEvidenceSearchSchema } from '@features/client/reports/priceEvidenceSearch';

export const Route = createFileRoute('/c/$orgId/$portalId/reports/$reportCode')({
  validateSearch: search => priceEvidenceSearchSchema.parse(search),
  component: RouteComponent,
});

function RouteComponent() {
  const { reportCode } = Route.useParams();

  return (
    <UserLayout>
      <ReportPage reportCode={reportCode} />
    </UserLayout>
  );
}
